import React from "react";
import { evaluatePassword } from "../lib/passwordPolicy";
import { Check, X } from "lucide-react";

/**
 * Indicador visual de fortaleza de contraseña.
 * Muestra barra de progreso + checklist de reglas.
 */
export default function PasswordStrengthMeter({ value, testIdPrefix = "pwd" }) {
  const { checks, passed, total, strengthColor, strengthLabel, isValid } = evaluatePassword(value);
  const pct = (passed / total) * 100;
  if (!value) return null;
  return (
    <div className="mt-2 space-y-2" data-testid={`${testIdPrefix}-strength-meter`}>
      <div className="flex items-center gap-2">
        <div className="h-1.5 flex-1 bg-gray-200 rounded-sm overflow-hidden">
          <div
            className={`h-full transition-all duration-200 ${strengthColor}`}
            style={{ width: `${pct}%` }}
          />
        </div>
        <span
          className={`text-[11px] font-medium ${
            isValid ? "text-emerald-700" : passed >= 3 ? "text-amber-700" : "text-red-700"
          }`}
          data-testid={`${testIdPrefix}-strength-label`}
        >
          {strengthLabel}
        </span>
      </div>
      <ul className="space-y-0.5">
        {checks.map((c) => (
          <li
            key={c.key}
            className={`text-[11px] flex items-center gap-1 ${c.ok ? "text-emerald-700" : "text-gray-500"}`}
            data-testid={`${testIdPrefix}-rule-${c.key}`}
          >
            {c.ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3 text-gray-400" />}
            {c.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
